import React from 'react';
import ResourceProperty from '../../../../common/resource/ResourceProperty';
import Table from '../../../../common/Table';
import { TICKET_POSTPONE_PROCESS_TICKET_COLUMNS } from '../../../../../config/columns';
import { filterMethodCaseInsensitive } from '../../../../../utils/filter-methods';
import { TICKET_PATH } from '../../../../../config/paths';
import { tzNormalizeDate } from '../../../../../utils/date';
import { DATE_TIME_FORMAT } from '../../../../../config/locale';
import ticketMassivePostponePropTypes from '../proptypes/TicketMassivePostponePropTypes';

const TicketMassivePostponeInformationResource = ({
  id,
  comment,
  ticketList,
  operatorUserName,
  agencyName,
  createDate,
}) => (
  <>
    <ResourceProperty label="Código:">{id || '-'}</ResourceProperty>
    <ResourceProperty label="Usuario Operador:">
      {operatorUserName || '-'}
    </ResourceProperty>
    <ResourceProperty label="Agencia:">{agencyName || '-'}</ResourceProperty>
    <ResourceProperty label="Comentario:">{comment || '-'}</ResourceProperty>
    <ResourceProperty label="Fecha de Creación:">
      {createDate
        ? tzNormalizeDate({ date: createDate, format: DATE_TIME_FORMAT }) || '-'
        : '-'}
    </ResourceProperty>
    <h4>Boletos Postergados</h4>
    <Table
      columns={TICKET_POSTPONE_PROCESS_TICKET_COLUMNS}
      data={ticketList}
      manual={false}
      filterable
      defaultFilterMethod={filterMethodCaseInsensitive}
      modelPath={TICKET_PATH}
      navigateToModelOnRowClick
      openPathInNewTab
      modelId="ticketId"
    />
  </>
);

TicketMassivePostponeInformationResource.propTypes =
  ticketMassivePostponePropTypes;

export default TicketMassivePostponeInformationResource;
